import React, {useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import "../../App.css";
import { makeStyles } from "@material-ui/core/styles";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";

import ActiveRampFlights from "./components/ActiveRampFlights";
import FlightMonitorStyles from "./styles/FlightMonitorStyles";
import AircraftGrid from "../Aircraft/components/AircraftGrid";
import moment from "moment";
import {useInterval} from "../../functions/useInterval";

const AccessControl = require ("../../AccessControl");

function FlightMonitor(props) {
  const classes = makeStyles(FlightMonitorStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "View RAMP"]);

  const ZuluClock = () => {
    const [zuluTime, setZuluTime] = useState (moment.utc().format("HH:mm"));

    useInterval(() => {
      setZuluTime(moment.utc().format("HH:mm"));
    }, 600);

    return (<span style={{color: "#f7c024", fontWeight: "bolder", fontSize: 18}}>{zuluTime} Zulu</span>);
  }

  return (isAuthenticated &&
    <div
      className="ActiveRampFlights"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="flightmonitor"
        pageName="Flight Monitor"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div
        className={classes.pageMargins + " clearfix"}
        style={{display: "flex", minHeight: `calc(100vh - ${(99+2+10+57+4)}px)`, maxHeight: `calc(100vh - ${(99+2+10+57+4+10+10)}px)`, overflow: "hidden", marginLeft: 40, marginRight: 40}}
      >
        {/*<div*/}
        {/*  style={{ overflow: "scroll", minWidth: 190, maxWidth: 190}}*/}
        {/*>*/}
        {/*  /!*<ZuluClock/>*!/*/}
        {/*  /!*<div style={{height: 10}}></div>*!/*/}
        {/*  <AircraftGrid/>*/}
        {/*</div>*/}
        <ActiveRampFlights canEdit={canEdit}/>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default FlightMonitor;
